import React from "react";
import { Container } from "./Styled";
import PageHeader from "../../pageHeader/PageHeader";
import { changeSelectedBotAction } from "../../../business/actions/botActions";

type HomeLayoutProps = {
    title?: string,
    subTitle?: string,
    onBackDestination?: string,
    children: React.ReactNode
};

export const BuilderLayout: React.FunctionComponent<HomeLayoutProps> = ({ title, subTitle, onBackDestination, children }) => {
    return (
        <div style={{ display: 'flex', height: '100%', flexDirection: 'column' }}>
            <PageHeader
                style={{
                    borderStyle: 'solid',
                    padding: '10px 24px 10px 30px',
                    borderWidth: '0px 0px 1px 0px',
                    borderColor: '#ececec'
                }}
                onBotSelect={changeSelectedBotAction.request}
                showBotSelector={true}
                onBackDestination={onBackDestination}
                title={title}
                subTitle={subTitle}
            />
            <Container>
                {children}
            </Container>
        </div>
    );
};

export default BuilderLayout;
